import {
  SET_CURRENT_TIME,
  SET_USER_TIME,
  RESET_CURRENT_TIME,
} from './mutation-types';

export default {
  [SET_CURRENT_TIME](state, payload) {
    state.currentTimeSec = payload;
  },
  [SET_USER_TIME](state, payload) {
    state.userTimeSec = payload;
  },
  [RESET_CURRENT_TIME](state) {
    state.currentTimeSec = 0.0;
  },
};
